import { memo } from 'react';

import { CellText, CompareItemImage, CompareItemWrapper, TableDataCell, TableRow } from './styles';

/**
 * 셀(Cell) 관련 스타일 상태를 계산
 * - 하이라이팅 개수가 가장 많은 옵션만 옵션명에 하이라이팅 (정책)
 */
const getCellState = (cellIndex: number, rowFlags: boolean[] | undefined) => {
  const isRowHeader = cellIndex === 0;
  const isHighlighted = !!rowFlags?.[cellIndex];

  return { isRowHeader, isHighlighted };
};

interface DataRowsProps {
  rows: string[][];
  hasCompareRow: boolean;
  highlightFlags?: boolean[][];
  fixedColumnWidth: string;
  columnMinWidth: string;
  compareRowImage?: string;
  onCompareClick?: () => void;
}

export const DataRows = memo(
  ({
    rows,
    hasCompareRow,
    highlightFlags,
    fixedColumnWidth,
    columnMinWidth,
    compareRowImage,
    onCompareClick,
  }: DataRowsProps) => {
    return (
      <>
        {rows.map((row, rowIndex) => {
          const isCompareRow = false;

          const rowFlags = highlightFlags ? highlightFlags[rowIndex] : undefined;

          return (
            <TableRow key={row[0]} hasBorder isCompareRow={isCompareRow}>
              {row.map((cell, cellIndex) => {
                const { isRowHeader, isHighlighted } = getCellState(cellIndex, rowFlags);

                const shouldHighlight = isHighlighted;

                const isMySizeHeader = isCompareRow && isRowHeader && cell === '내 사이즈';
                const handleClick = isMySizeHeader ? onCompareClick : undefined;

                return (
                  <TableDataCell
                    key={cellIndex}
                    width={isRowHeader ? fixedColumnWidth : columnMinWidth}
                    isSticky={isRowHeader}
                    isCompareRow={isCompareRow}
                    isHighlighted={shouldHighlight}
                    isRowHeader={isRowHeader}
                    onClick={handleClick}
                    style={isMySizeHeader ? { cursor: 'pointer', textDecoration: 'underline' } : undefined}
                  >
                    {isCompareRow && isRowHeader ? (
                      <CompareItemWrapper isCompareRow={isCompareRow}>
                        {compareRowImage && <CompareItemImage src={compareRowImage} alt='비교상품' />}
                        <CellText isRowHeader isCompareRow={isCompareRow} hasImage={!!compareRowImage}>
                          {cell}
                        </CellText>
                      </CompareItemWrapper>
                    ) : (
                      <CellText
                        isHighlighted={shouldHighlight}
                        isRowHeader={isRowHeader}
                        isCompareRow={isCompareRow}
                        hasImage={false}
                      >
                        {cell}
                      </CellText>
                    )}
                  </TableDataCell>
                );
              })}
            </TableRow>
          );
        })}
      </>
    );
  },
);
